module.exports = __webpack_public_path__ + "img/vento.e21ffaf1.png";